import { gql } from '@apollo/client'

export const UPDATE_USER_MUTATION = gql`
  mutation updateUser($attributes: UserInput!) {
    updateUser(attributes: $attributes) {
      id
      firstname
      lastname
      birthDate
      email
      street
      houseNumber
      place
      postalCode
      mobileNumber
      phoneNumber
      portalEmail
      portalPhoneNumber
      portalMobileNumber
      callViaVoip
      languages
    }
  }
`
